import { render, staticRenderFns } from "./AdminPanelYoutvPackageSellingHistory.vue?vue&type=template&id=0db6217e&"
import script from "./AdminPanelYoutvPackageSellingHistory.vue?vue&type=script&lang=js&"
export * from "./AdminPanelYoutvPackageSellingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports